// Plain JavaScript version of your Stimulus controller

// Constants
const CONTROLLER = "data-mobile-menu-target";
const TARGET_CONTENT = "content";
const TARGET_OPEN_BTN = "open-btn";
const TARGET_CLOSE_BTN = "close-btn";
const TARGET_SUBMENU_LINK = "submenu-link";
const TARGET_LEVEL_MENU = "level-menu";
const OUTSIDE_TARGET = "outside";

const CLASS_MENU_OPEN = "tvsu-mobile__open";
const CLASS_LOCK = "tvsu-lock";
const CLASS_HIDDEN = "d-none";

// Utility functions
const getElement = (name) => {
  return document.querySelector(`[${CONTROLLER}~="${name}"]`);
};

const getElements = (name) => {
  return document.querySelectorAll(`[${CONTROLLER}~="${name}"]`);
};

export class MobileMenu {
  constructor() {
    if (this.connectTargets()) {
      this.connect();
    }
  }

  destroy() {
    this.unbindActions();
  }

  connectTargets() {
    this.contentTarget = getElement(TARGET_CONTENT);
    if (!this.contentTarget) {
      return false;
    }

    this.pageBodyTarget = document.querySelector("body");
    this.openBtnTarget = getElement(TARGET_OPEN_BTN);
    this.closeBtnTarget = getElement(TARGET_CLOSE_BTN);
    this.outsideTarget = getElement(OUTSIDE_TARGET);
    this.submenuLinkTargets = Array.from(getElements(TARGET_SUBMENU_LINK));
    this.levelMenuTargets = Array.from(getElements(TARGET_LEVEL_MENU));
    return true;
  }

  connect() {
    this._showMenu = this.showMenu.bind(this);
    this._closeMenu = this.closeMenu.bind(this);
    this._switchMenu = this.switchMenu.bind(this);

    this.bindActions();
  }

  bindActions() {
    this.outsideTarget.addEventListener("click", (e) => {
      e.preventDefault();
      this.closeMenu(e);
    })
    this.openBtnTarget.addEventListener("click", this._showMenu);
    this.closeBtnTarget.addEventListener("click", this._closeMenu);
    this.submenuLinkTargets.forEach((link) => {
      link.addEventListener("click", this._switchMenu);
    });
  }

  unbindActions() {
    this.openBtnTarget.removeEventListener("click", this._showMenu);
    this.closeBtnTarget.removeEventListener("click", this._closeMenu);
    this.submenuLinkTargets.forEach((link) => {
      link.removeEventListener("click", this._switchMenu);
    });
  }

  showMenu(event) {
    event.preventDefault();
    this.contentTarget.classList.add(CLASS_MENU_OPEN);
    this.pageBodyTarget.classList.add(CLASS_LOCK);
  }

  closeMenu(event) {
    event.preventDefault();
    this.contentTarget.classList.remove(CLASS_MENU_OPEN);
    this.pageBodyTarget.classList.remove(CLASS_LOCK);
  }

  switchMenu(event) {
    event.preventDefault();
    const target = event.target;
    const url = target.getAttribute("href").replace("#", "");
    const menu = this.levelMenuTargets.find((el) => el.dataset.level === url);
    if (!menu) {
      return;
    }
    this.levelMenuTargets.forEach((level) =>
      level.classList.add(CLASS_HIDDEN)
    );
    menu.classList.remove(CLASS_HIDDEN);
  }
}
